import { createBrowserRouter } from 'react-router';
import { RequireAuth, RequireSuperAdmin } from './components/auth/guards';
import { AppShell } from './components/layout/AppShell';
import { HomePage } from './pages/HomePage';
import { LoginPage } from './pages/LoginPage';
import { MembersPage } from './pages/MembersPage';
import { ProductPage } from './pages/products/ProductPage';
import { DocumentReviewPage } from './pages/documents/DocumentReviewPage';
import { ProductsPage } from './pages/products/ProductsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { RouteErrorPage } from './pages/RouteErrorPage';
import { NewOrgPage } from './pages/superadmin/NewOrgPage';
import { OrgDetailPage } from './pages/superadmin/OrgDetailPage';
import { OrgsPage } from './pages/superadmin/OrgsPage';
import { SuperAdminsPage } from './pages/superadmin/SuperAdminsPage';
import { KbPage } from './pages/superadmin/KbPage';
import { NutrientsPage } from './pages/superadmin/NutrientsPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <RouteErrorPage />,
    children: [
      { path: 'login', element: <LoginPage /> },
      {
        element: <RequireAuth />,
        children: [
          { index: true, element: <HomePage /> },
          { path: 'members', element: <MembersPage /> },
          { path: 'products', element: <ProductsPage /> },
          { path: 'products/:pid', element: <ProductPage /> },
          { path: 'products/:pid/documents/:docId', element: <DocumentReviewPage /> },
          {
            path: 'superadmin',
            element: <RequireSuperAdmin />,
            children: [
              { index: true, element: <OrgsPage /> },
              { path: 'orgs/new', element: <NewOrgPage /> },
              { path: 'orgs/:orgId', element: <OrgDetailPage /> },
              { path: 'superadmins', element: <SuperAdminsPage /> },
              { path: 'kb', element: <KbPage /> },
              { path: 'nutrients', element: <NutrientsPage /> },
            ],
          },
          { path: '*', element: <NotFoundPage /> },
        ],
      },
    ],
  },
]);
